import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { adminGuard } from './core/auth/admin.guard';
import { unsavedChangesGuard } from './core/navigation/unsaved-changes.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./shared/layout/shell.layout').then((m) => m.ShellLayout),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard.page').then((m) => m.DashboardPage),
      },
      {
        path: 'field',
        loadComponent: () =>
          import('./features/field/field-home.page').then((m) => m.FieldHomePage),
      },
      {
        path: 'field/survey/:versionId',
        loadComponent: () =>
          import('./features/field/field-survey.page').then((m) => m.FieldSurveyPage),
      },
      {
        path: 'reports',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/reports/reports.page').then((m) => m.ReportsPage),
      },
      {
        path: 'users',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/users/users.page').then((m) => m.UsersPage),
      },
      {
        path: 'forms',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/forms/forms.page').then((m) => m.FormsPage),
      },
      {
        path: 'forms/:id',
        canActivate: [adminGuard],
        canDeactivate: [unsavedChangesGuard],
        loadComponent: () =>
          import('./features/forms/form-detail.page').then((m) => m.FormDetailPage),
      },
      {
        path: 'catalogs',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/catalogs/catalogs.page').then((m) => m.CatalogsPage),
      },
      {
        path: 'catalogs/:id',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/catalogs/catalog-detail.page').then((m) => m.CatalogDetailPage),
      },
      {
        path: 'territory',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/territory/territory.page').then((m) => m.TerritoryPage),
      },
      {
        path: 'surveys',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/surveys/surveys.page').then((m) => m.SurveysPage),
      },
      {
        path: 'alerts',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/alerts/alerts.page').then((m) => m.AlertsPage),
      },
      {
        path: 'quotas',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/quotas/quotas.page').then((m) => m.QuotasPage),
      },
      {
        path: 'settings/params',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/settings/params.page').then((m) => m.ParamsPage),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
